import { useEffect, useMemo } from 'react';
import * as bd from 'react-basic-design';
import { ExpiringContractDTO, useExpiringContractApi } from '../../../api/contract-api';
import { InitFailed } from '../../../components/basic/init-failed';
import { Loading } from '../../../components/basic/loading';
import { N } from '../../../components/basic/n';
import { T } from '../../../components/basic/text';
import { DateCell } from '../../../components/table/table-cells';
import { IBasicTableColumn } from '../../../interfaces/interfaces';
import { calculateRemainingTime } from './contract-helper';

export const ExpiringContracts = () => {
    const expiringContractService = useExpiringContractApi();

    const { result, error, initialized, initializing } = expiringContractService;

    const columns: IBasicTableColumn<ExpiringContractDTO>[] = useMemo(
        () => [
            {
                Header: <T>id</T>,
                name: 'id',
                width: 20,
                Cell: ({ row }) => <N>{row.id}</N>,
            },
            {
                Header: <T>board-id</T>,
                name: 'boardTitle',
            },
            {
                Header: <T>customer-id</T>,
                name: 'customerName',
            },
            {
                Header: <T>company-name</T>,
                name: 'companyName',
            },
            {
                Header: <T>start-date</T>,
                name: 'startDate',
                width: 150,
                Cell: DateCell,
            },
            {
                Header: <T>end-date</T>,
                name: 'endDate',
                width: 150,
                Cell: DateCell,
            },
            {
                Header: <T>contract-status</T>,
                name: 'endDate',
                width: 150,
                Cell: ({ row }: { row: any }) =>
                    expiringContractService?.result ? (
                        calculateRemainingTime(expiringContractService?.result?.now, row.endDate)
                    ) : (
                        <></>
                    ),
            },
        ],
        [expiringContractService?.result]
    );

    useEffect(() => {
        if (initialized || initializing || error) return;
        expiringContractService.post(null, {});
    }, [initialized, initializing, error]);

    if (error)
        return <InitFailed ex={error} onRetry={() => expiringContractService.post(null, {})} />;
    if (!initialized || initializing) return <Loading />;

    return (
        <div className="m-3 p-1 ">
            <T className="text-muted">expiring-contracts</T>

            <div className="p-1 mt-3" style={{ maxWidth: 1000 }}>
                <bd.BasicTable
                    className="bg-white border"
                    columns={columns}
                    data={result.expiringContracts}
                    hover
                >
                    <T as="div" className="nothing-found">
                        no-expiring-contracts-found
                    </T>
                </bd.BasicTable>
            </div>
        </div>
    );
};
